import { createSelector } from '@reduxjs/toolkit';

export const selectWalletsByTicker = createSelector(
  (state) => state.calculator,
  (_, ticker) => ticker,
  ({ walletsList }, ticker) =>
    walletsList.filter(({ currency_ticker }) => currency_ticker === ticker)
);
